import { Controller } from "stimulus"

export default class extends Controller {
  static values = {
    billingMatterType: String,
    costAccrualRatio: Number,
    issuedInvoicedAmount: Number,
    remainInvoiceAmount: Number
  }

  numberChanged() {
    const billingMatterType = this.billingMatterTypeValue;
    const isTaxedBillingMatter = ['retained_production_value', 'production_value_settlement'].includes(billingMatterType);
    const saveBtn = $('#new-invoice-approval-save-btn');
    const applicationAmountText = $('#applicationAmount').val();
    const applicationAmount = parseFloat(applicationAmountText);
    const selectedText = $('#taxRate option:selected').text();
    const selectTax = parseFloat(selectedText) / 100.0;

    if (Number.isNaN(applicationAmount) || Number.isNaN(selectTax)) {
      $('#calculatedText').html('');
      saveBtn.attr('disabled', true);
      return;
    }

    // applicationAmount input meaning:
    // - taxed billing matters: invoice_amount_with_tax
    // - non-taxed billing matters: application_invoice_amount_without_tax
    const applicationAmountWithOrWithoutTax = applicationAmount;

    let amountWithoutTax = 0;
    let amountWithTax = 0;
    if (isTaxedBillingMatter) {
      amountWithTax = applicationAmount;
      amountWithoutTax = amountWithTax / (1 + selectTax);
    } else {
      amountWithoutTax = applicationAmount;
      amountWithTax = amountWithoutTax * (1 + selectTax);
    }
    const invoiceTax = amountWithTax - amountWithoutTax;

    const text = `
      <p>不含税金额：${amountWithoutTax.toFixed(2)}，开票税额：${invoiceTax.toFixed(2)}，价税合计：${amountWithTax.toFixed(2)}；</p>
      <p>成本计提比例：${this.costAccrualRatioValue}%，成本计提金额：${(applicationAmountWithOrWithoutTax*(this.costAccrualRatioValue / 100.0)).toFixed(2)}。</p>
    `
    $('#calculatedText').html(text);

    if (this.remainInvoiceAmountValue >= 0) {
      if (Math.round(this.remainInvoiceAmountValue * 100) >= Math.round(applicationAmountWithOrWithoutTax * 100)) {
        saveBtn.attr('disabled', false);
      } else {
        saveBtn.attr('disabled', true);
      }
    } else {
      if (0 > Math.round(applicationAmountWithOrWithoutTax * 100) && (Math.round(applicationAmountWithOrWithoutTax * 100) >= -Math.round(this.issuedInvoicedAmountValue * 100))) {
        saveBtn.attr('disabled', false);
      } else {
        saveBtn.attr('disabled', true);
      }
    }
  }
}
